__turbopack_context__.v({
  "button": "NotFoundPage-module-scss-module___3JNxa__button",
  "container": "NotFoundPage-module-scss-module___3JNxa__container",
  "containerWrapper": "NotFoundPage-module-scss-module___3JNxa__containerWrapper",
  "link": "NotFoundPage-module-scss-module___3JNxa__link",
  "root": "NotFoundPage-module-scss-module___3JNxa__root",
});
